import { REMOVE_USER_ERROR } from "../types";

export default function(category, question) {
  return {
    category,
    question,
    type: REMOVE_USER_ERROR
  };
}
